function AssetSummaryPane($scope, $element, $compile, $timeout) {  
    'use strict';
    this.$scope = $scope;
    this.$element = $element;
    this.$compile = $compile;
    this.$timeout = $timeout;
    this.baseVideoMarkup = '<video class="video-js vjs-default-skin" controls preload="auto" width="640"> <source ng-src="{{asset.src | cdnPath}}" type="{{asset.contentType}}"/></video>';

}

AssetSummaryPane.prototype.watchAsset = function(updated) {
    'use strict';
    if(!!updated) {
        if(updated.contentType.startsWith("video/")) {
            let videoEle = this.$element.find(".preview-video");
            videoEle.find("video").remove();
            let compiledMarkup = this.$compile(this.baseVideoMarkup)(this.$scope);
            // videoEle.html(compiledMarkup)
            videoEle.append(compiledMarkup);
        }
        else if(updated.contentType === "x-reflow/adunit") {
            this.getAdunitMarkup(updated);
        }
        else if(updated.contentType === "x-reflow/rss-feed") {
            this.getRssFeed(updated);
        }
        else {
            this.$scope.tagMarkup = this.$scope.tagTrustedMarkup = "";
        }
    }
    
};

AssetSummaryPane.prototype.renderAdunitPreview = function(markup, dimensions) {
    'use strict';
    let self = this;
    var content = $(".preview-tag-view > div.preview-adunit", self.$element);
    content.empty();

    var frame = document.createElement("iframe");
    frame.src = "about:blank";
    frame.setAttribute("webkitallowfullscreen", true);
    frame.setAttribute("mozallowfullscreen", true);     
    frame.frameBorder = 0;
    frame.scrolling = "no";
    frame.marginWidth = 0;
    frame.marginHeight = 0;
    frame.hspace = 0;
    frame.vspace = 0;
    frame.seamless = true;
    frame.allowTransparency = true;
    frame.allowFullscreen = true;

    var cssDims = "";
    if("undefined" != typeof dimensions) {
        cssDims = "width:" + dimensions.width + "px; height: " + dimensions.height + "px;";
    }

    frame.style.cssText = cssDims + " border: 0; margin 0; padding: 0;";
    
    content.append(frame);

    frame.contentWindow.document.open();
    frame.contentWindow.document.charset = "UTF-8";
    frame.contentWindow.document.write(markup);
    frame.contentWindow.document.close();
};

AssetSummaryPane.prototype.getAdunitMarkup = function(asset) {  
    'use strict';  
    var self = this;
    if(this.paneIsVisible(self.$element)) {
        self.$tagService.getCampaignManagerPreview(asset._id, function(markup) {
            // window["INSERT_AT_" + asset.id] = $(".preview-tag-view > div.preview-adunit", self.$element).get(0);
            // var iframe = $("<iframe id='#preview-iframe'></iframe>");
            // iframe.contents().find("body").html("<p>new HTML content goes here</p>");

            if(markup) {
                self.renderAdunitPreview(markup);
            }
            else {
                self.$tagService.getTagMarkup(asset._id, null, null, false, true, function(data) {
                    self.renderAdunitPreview(data);
                });
            }
        });
    }
};

AssetSummaryPane.prototype.paneIsVisible = function($el) {
    'use strict';
    return $el.parents("reflow-pane.ng-hide").length === 0;
};


angular.module("cpm").directive("assetSummaryPane", ['CreativeService', '$compile', '$timeout', function(CreativeService, $compile, $timeout){
    'use strict';
    return {
        restrict: "E",
        templateUrl: "asset-library/asset-summary-pane.html",
        scope: {
            asset: "="
        },
        link: function($scope, $element, $attributes) {
                        
            var delegate = new AssetSummaryPane($scope, $element, $compile, $timeout);
            
            $scope.$watch("asset", function(updated) {
                delegate.watchAsset(updated);
            });
             
        }
    };  
}]);
